function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M271,393.516V375c0-15.352,5.977-29.766,16.816-40.605l5.094-5.094C347.534,325.666,391,280.525,391,225 c0-8.291-6.709-15-15-15c-55.525,0-100.666,43.466-104.301,98.09l-5.094,5.094c-3.994,3.986-7.504,8.32-10.605,12.887 c-3.102-4.567-6.612-8.901-10.605-12.887l-5.094-5.094C236.666,253.466,191.525,210,136,210c-8.291,0-15,6.709-15,15 c0,55.525,43.466,100.666,98.09,104.301l5.094,5.094C235.023,345.234,241,359.648,241,375v18.516 c-50.75,7.357-90,50.729-90,103.484c0,8.291,6.709,15,15,15h180c8.291,0,15-6.709,15-15C361,444.245,321.75,400.873,271,393.516z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M222.162,64.98c-5.684-6.328-16.641-6.328-22.324,0C191.693,74.063,151,120.879,151,150c0,33.091,26.924,60,60,60 s60-26.909,60-60C271,120.879,230.307,74.062,222.162,64.98z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M356.723,55.869c-0.176-0.381-0.352-0.747-0.557-1.099L329.008,7.529C326.342,2.871,321.361,0,316,0 c-5.361,0-10.313,2.856-13.008,7.5l-25.107,43.608C273.373,58.257,271,66.519,271,75c0,24.814,20.186,45,45,45 c24.814,0,45-20.186,45-45C361,68.32,359.564,61.89,356.723,55.869z"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

function Svg1010(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    fill: "inherit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1010);
export default __webpack_public_path__ + "static/media/10_10.87ca06a9.svg";
export { ForwardRef as ReactComponent };